import React, { createContext, useContext, useState, ReactNode } from 'react';
import { PersonInfo } from '../models/person.model';

interface PersonFilterContextType {
  filteredPersons: PersonInfo[];
  setFilteredPersons: (persons: PersonInfo[]) => void;
  filterTitle: string;
  setFilterTitle: (title: string) => void;
  clearFilter: () => void;
  isFiltered: boolean;
}

const PersonFilterContext = createContext<PersonFilterContextType | undefined>(undefined);

interface PersonFilterProviderProps {
  children: ReactNode;
}

export function PersonFilterProvider({ children }: PersonFilterProviderProps) {
  const [filteredPersons, setFilteredPersons] = useState<PersonInfo[]>([]);
  const [filterTitle, setFilterTitle] = useState<string>('');

  const clearFilter = () => {
    setFilteredPersons([]);
    setFilterTitle('');
  };

  const isFiltered = filteredPersons.length > 0;

  return (
    <PersonFilterContext.Provider
      value={{
        filteredPersons,
        setFilteredPersons,
        filterTitle,
        setFilterTitle,
        clearFilter,
        isFiltered,
      }}
    >
      {children}
    </PersonFilterContext.Provider>
  );
}

export function usePersonFilter() {
  const context = useContext(PersonFilterContext);
  if (context === undefined) {
    throw new Error('usePersonFilter must be used within a PersonFilterProvider');
  }
  return context;
} 